module.exports = __webpack_public_path__ + "img/fase2Capture-play.fe1066bc.jpg";